<template>
  <form class="default-form row">
    <div class="form-group col-lg-12 dropdown-wrapper">
      <div class="dropdown" @click="showDropdown('cityDropdown')">
        {{ city }}
        <div
          class="dropdownList"
          :class="{ active: dropdown == 'cityDropdown' }"
        >
          <ul
            v-show="dropdown == 'cityDropdown'"
            @mouseleave="showDropdown('')"
          >
            <li>
              <input
                type="text"
                class="citySearch"
                v-model="searchCity"
                placeholder="Search"
              />
            </li>
            <li v-for="city in cities" :key="city" @click.stop="setCity(city)">
              {{ city }}
            </li>
          </ul>
        </div>
      </div>

      <!-- <select v-model="city">
          <option v-for="city in cities" :key="city">{{city}}</option>
        </select>   -->
    </div>
    <div class="form-group col-lg-12 dropdown-wrapper">
      <!-- <select v-model="da">
          <option v-for="cda in deliveryAreas" :key="cda">{{cda}}</option>
        </select>   -->
      <div class="dropdown" @click="showDropdown('daDropdown')">
        {{ da }}
        <div class="dropdownList" :class="{ active: dropdown == 'daDropdown' }">
          <ul v-show="dropdown == 'daDropdown'" @mouseleave="showDropdown('')">
            <li>
              <input
                type="text"
                class="citySearch"
                v-model="searchDa"
                placeholder="Search"
              />
            </li>
            <li
              v-for="cda in deliveryAreas"
              :key="cda"
              @click.stop="setDa(cda)"
            >
              {{ cda }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <loader v-show="processInProgress(process)" />
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
import Loader from '@/components/Elements/Loader.vue'
export default {
  name: 'selectDeliveryAreaForm',
  components: {
    Loader,
  },
  data() {
    return {
      city: this.locationCity || 'Select City',
      da: this.selectedDa || 'Select Delivery area',
      dropdown: '',
      searchCity: '',
      searchDa: '',
      process: 'load-selected-store',
    }
  },

  computed: {
    ...mapGetters([
      '_T',
      '_T_DB',
      'brand_all_delivery_areas',
      'brand_all_delivery_areas_split',
      'find_delivery_areas_by_value',
      'brand_find_delivery_areas_by_value',
      'selectedDa',
      'locationCity',
      'selectedCountry',
      'currentBrand',
      'processInProgress',
    ]),

    cities() {
      if (this.brand_all_delivery_areas_split) {
        const cities = this.brand_all_delivery_areas_split['cities']
        let currentCities = []
        for (const i in cities) {
          if (cities[i].country == this.selectedCountry) {
            //currentCities.push(i)
            if (this.searchCity) {
              if (
                i.substr(0, this.searchCity.length).toLowerCase() ==
                this.searchCity.toLowerCase()
              ) {
                currentCities.push(i)
              } else if (
                i.match(new RegExp(this.searchCity.toLowerCase(), 'i'))
              ) {
                currentCities.push(i)
              }
            } else {
              currentCities.push(i)
            }
          }
        }
        return currentCities
      }
      return {}
    },
    deliveryAreas() {
      if (this.brand_all_delivery_areas_split) {
        const das = this.brand_all_delivery_areas_split['das']
        let currentDas = []
        for (const i in das) {
          if (das[i].city == this.city) {
            //currentDas.push(i)
            if (this.searchDa) {
              if (
                i.substr(0, this.searchDa.length).toLowerCase() ==
                this.searchDa.toLowerCase()
              ) {
                currentDas.push(i)
              } else if (
                i.match(new RegExp(this.searchDa.toLowerCase(), 'i'))
              ) {
                currentDas.push(i)
              }
            } else {
              currentDas.push(i)
            }
          }
        }
        return currentDas
      }
      return {}
    },
  },
  methods: {
    setCity(city) {
      this.city = city
      this.$store.commit('SET_SELECTED_CITY', city)
      this.dropdown = ''
      this.da = 'Select Delivery Area'
    },
    setDa(da) {
      this.da = da
      this.$store.commit('SET_SELECTED_DA', da)
      this.dropdown = ''
      //no need to call action, I ll use getter instead
      //this.$store.dispatch('selectDA')
    },
    showDropdown(ref) {
      this.dropdown = ref
    },
    setMutations(all = true) {
      this.$store.commit('SET_SELECTED_CITY', this.city)
      this.$store.commit('SET_SELECTED_DA', this.da)
      if (all) {
        this.$store.commit('SET_SELECTED_CHECKOUT_STORE', undefined)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.dropdown-wrapper {
  position: relative;
  .dropdown {
    position: relative;
    cursor: pointer;
    font-size: 0.875rem;
    padding: 0.9375rem 0.8125rem;
    border-radius: 0.375rem;
    height: auto;
    line-height: 1.375rem;
    letter-spacing: 0.5px;
    font-weight: 600;
    border: 1px solid;
    color: var(--color-font-color);
    border-color: var(--color-light-border);

    .dropdownList {
      display: none;
      position: absolute;
      z-index: 99;
      background-color: #fff;
      padding-right: 15px;
      padding-left: 15px;
      margin-left: -15px;
      margin-top: 0.99rem;
      width: 100%;
      max-height: 20rem;
      overflow: auto;
      border: 0.0625rem solid var(--color-light-border);
      -webkit-transition: all 0.5s ease;
      transition: all 0.5s ease;

      &.active {
        display: block;
      }
      li {
        display: block;
        font-size: 0.875rem;
        padding: 0.9375rem 0;
        height: auto;
        line-height: 1.375rem;
        letter-spacing: 0.5px;
        font-weight: 600;
        color: var(--color-font-color);
        border-bottom: 1px solid;
        border-color: var(--color-light-border);
        width: 100%;
        input {
          width: 100%;
        }
      }
    }
    &::after {
      content: '\25BE';
      text-align: right;
      float: right;
    }
  }
}
</style>
<style scoped>
.dropdownList {
  box-shadow: 0px 0.875rem 2.125rem rgb(0 0 0 / 10%);
}
</style>
